<template>
<div class="content-class">
	<v-tabs v-model="active" color="black" dark slider-color="primary">
		<v-tab :key="'navigation'" ripple>Navigation</v-tab>
		<v-tab :key="'users'" ripple>Utilisateur</v-tab>
		<v-tab :key="'Logs'" ripple>Logs</v-tab>

		<v-tab-item :key="'navigation'">
			<v-layout class="filter-navigation">
				<b-o-input ref="input" :input="{type :'date' ,label:'De'}" v-model="from"></b-o-input>
				<b-o-input ref="input" :input="{type :'date' ,label:'Jusqu\'au'}" v-model="to"></b-o-input>
			</v-layout>
			<navigation-list v-if="document" :documents='botNavigationVariables' :navigations="navigations">
			</navigation-list>
		</v-tab-item>

		<v-tab-item :key="'users'">
			<user-form v-model="document">
			</user-form>

			<v-btn color="error" :disabled="loading" @click="remove">
				Supprimer
				<v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
			</v-btn>
		</v-tab-item>

		<v-tab-item :key="'Logs'">
			<log-list :url="'logs?filter=references.reference:$eq:users;references.referenceId:$eq:'+$route.params.userId">
			</log-list>
		</v-tab-item>
	</v-tabs>
</div>
</template>
<script>
import UserForm from '../../components/users/user.form'
import NavigationList from '../../components/users/navigation.list'
import LogList from '../../components/logs/log.list.vue'
import BOInput from '../../baseComponents/boInput.vue'

import { ERROR } from '../../variables'

export default {
	components: { UserForm, LogList, NavigationList, BOInput },
	data() {
		return {
			loading: false,
			from: null,
			to: null,
			active: null,
			document: null
		}
	},
	methods: {
		async remove() {
			this.loading = true
			await this.axios.delete('users/' + this.document._id)
			this.loading = false
			this.$router.push({ name: 'UsersList', params: { botId: this.$route.params.botId } })
		}
	},
	computed: {
		navigations() {
			let start, end
			if (this.from) {
				start = new Date(this.from)
			}
			if (this.to) {
				end = new Date(this.to)
				end.setDate(end.getDate() + 1)
			}
			if (start || end) {
				let res = []
				for (let i = 0; i < this.document.navigationVariables.length; i++) {
					res.push({
						_id: this.document.navigationVariables[i]._id,
						value: this.document.navigationVariables[i].value,
						navigateAt: this.document.navigationVariables[i].navigateAt ? this.document.navigationVariables[i].navigateAt.filter((navigate) => {
							let begin = new Date(navigate.begin)
							if (start && end) {
								return begin.getTime() > start.getTime() && begin.getTime() < end.getTime()
							} else if (start) {
								return begin.getTime() > start.getTime()
							} else if (end) {
								return begin.getTime() < end.getTime()
							}
							return true
						}) : []
					})
				}
				return res
			}
			return this.document.navigationVariables
		},
		botNavigationVariables() {
			return this.$store.getters.botNavigationVariables
		}
	},
	mounted() {
		this.axios
			.get('users/' + this.$route.params.userId)
			.then(response => {
				this.document = response.data
			})
			.catch((err) => {
				this.$store.dispatch(ERROR, err)
			})
	}

}
</script>
<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;

    .filter-navigation {
        margin-left: auto;
        .layout {
            flex-grow: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/users/user.detail.vue